import { render, staticRenderFns } from "./TablesSaleQty.vue?vue&type=template&id=204e1d1a&scoped=true"
import script from "./TablesSaleQty.vue?vue&type=script&lang=js"
export * from "./TablesSaleQty.vue?vue&type=script&lang=js"
import style0 from "./TablesSaleQty.vue?vue&type=style&index=0&id=204e1d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e1d1a",
  null
  
)

export default component.exports